import { string } from 'prop-types';

import styles from '../BookingReview.scss';

export const BookingHeader = ({ title = '' }) => (
  <header className={styles.BookingReview__header} data-testid="appointmentHeader">
    {title || 'Appointment summary'}
  </header>
);

BookingHeader.propTypes = {
  title: string,
};
